import createManager from './logManager'
import defaultLogFormatter from './logFormatter'
import { logLevels as levelImport } from './constants'

/**
 * Package main.
 */

// Main export is the manager's factory function.
export default createManager

// Named export for the log level constants the package uses / expects.
export const logLevels = levelImport

// Default log formatter used by the defaultLogHandler
export const logFormatter = defaultLogFormatter
